import React from 'react';
import ReactDOM from 'react-dom/client';
import './util/init';
import Portal from './Portal';
import './css/buddy.css';
import './css/shared.css';
import './css/customers.css';

const DSN = process.env.CLIENT_SENTRY_DSN;
const STAGE = process.env.STAGE || 'LOCAL';
const RELEASE = process.env.CLIENT_SENTRY_RELEASE || `insured-portal@${process.env.npm_package_version || 'unknown'}`;

// Sentry Fast Async Loader (Error monitoring only)
const initSentry = async () => {
	const shouldIgnoreSentry = ['LOCAL', 'DEV'].includes(STAGE);

	if (!DSN) {
		return;
	}

	try {
		const { init } = await import('@sentry/react');

		init({
			dsn: DSN,
			environment: STAGE,
			release: RELEASE,
			enabled: true,
			debug: STAGE === 'LOCAL', // set to true to help with debugging
			beforeSend(event) {
				// Ignore Sentry errors in local/dev environments
				if (shouldIgnoreSentry) {
					return null;
				}
				return event;
			},
		});
	} catch (error) {
		// eslint-disable-next-line no-console
		console.warn('Sentry failed to load:', error);
	}
};

// Initialize Sentry asynchronously (non-blocking)
initSentry();

ReactDOM.createRoot(document.getElementById('root')).render(
	<React.StrictMode>
		<Portal />
	</React.StrictMode>,
);
